<template>
	<div class="createParks">
		<div class="main-filter">
			<el-form inline :model="formInline" class="demo-form-inline search-form">
				<el-form-item label="活动名称：">
					<el-autocomplete
						v-model.trim="formInline.name"
						:fetch-suggestions="querySearchAsync"
						clearable
						placeholder="请输入内容"
						@select="handleSelect"
					></el-autocomplete>
				</el-form-item>
				<el-form-item label="活动类型：">
					<el-select v-model="formInline.activityTypeDictionaryItemId" placeholder="请选择" clearable>
						<el-option v-for="(item, index) in activityTypeList" :key="index" :label="item.title" :value="item.id"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="onSearch" icon="el-icon-search">搜索</el-button>
				</el-form-item>
			</el-form>
		</div>
		<div class="main-content">
			<div class="main-content-title">
				<p>共有{{ total }}条结果</p>
				<el-button type="primary" @click="modifyParkInfo($event, false)" icon="el-icon-plus">新增</el-button>
			</div>
			<Table
				:loading="loading"
				:table-data="tableData"
				:total="total"
				:table-head="tableHead"
				:current-page.sync="queryData.current"
				:page-size.sync="queryData.size"
				:operation-column-width="160"
				:is-show-selection="false"
				:showOperation="true"
				@change-page="getList"
				:tableHeight="tableHeight"
			>
				<!-- 状态修改 -->
				<template #enabled="{ scope }">
					<el-switch active-text="是" inactive-text="否" v-model="scope.row.enabled" @change="onChangeStatus(scope.row)"> </el-switch>
				</template>
				<!-- 插槽操作栏固定属性operation -->
				<template #operation="{ scope }">
					<el-button @click="modifyParkInfo($event, true, scope.row)" size="mini" type="primary"> 查看 </el-button>
					<el-button
						@click="modifyParkInfo($event, false, scope.row)"
						size="mini"
						:type="scope.row.enabled ? 'info' : 'warning'"
						:disabled="scope.row.enabled"
					>
						修改
					</el-button>
				</template>
				<template #showDialog="{ scope }">
					<el-button @click="onShow(scope.row)" type="text">查看</el-button>
				</template>
			</Table>
		</div>
		<NewActivity ref="newActivity" @getList="getList" :isShowDetail="isShowDetail" :activityTypeList="activityTypeList" />
		<ShowList ref="showList" />
	</div>
</template>

<script>
export default {
	name: 'physicalActivity',
	components: {
		Table: () => import('@/components/Table/table'),
		NewActivity: () => import('./new.vue'),
		ShowList: () => import('./showList.vue'),
	},
	data() {
		return {
			activityTypeList: [],
			formInline: {
				name: null,
				activityTypeDictionaryItemId: null,
			},
			queryData: {
				current: 1,
				size: 10,
			},
			total: 0,
			loading: false,
			tableData: [],
			tableHead: [
				{
					label: '活动名称',
					prop: 'name',
					formatter: function (row) {
						return row.name || '-';
					},
				},
				{
					label: '活动时间',
					prop: 'startTime',
					width: 320,
					formatter: function (row) {
						return row.startTime && row.endTime ? `${row.startTime} 至 ${row.endTime}` : '-';
					},
				},
				{
					label: '报名时间',
					prop: 'registrationEndTime',
					width: 320,
					formatter: function (row) {
						return row.registrationEndTime ? `${row.registrationStartTime} 至 ${row.registrationEndTime}` : '-';
					},
				},
				{
					label: '联系人',
					prop: 'contactName',
					formatter: function (row) {
						return row.contactName || '-';
					},
				},
				{
					label: '联系电话',
					prop: 'phoneNumber',
					formatter: function (row) {
						return row.phoneNumber || '-';
					},
				},
				{
					label: '报名名单',
					prop: 'showDialog',
				},
				{
					label: '活动状态',
					prop: 'state',
					formatter: function (row) {
						return row.state === 'P' ? '活动中' : row.state === 'N' ? '未开始' : row.state === 'E' ? '已结束' : '-';
					},
				},
			],
			filterLoading: false,
			scenicSpotList: [],
			isShowDetail: false,
			link: '',
		};
	},
	computed: {
		tableHeight() {
			return window.innerHeight - 300;
		},
	},
	mounted() {
		this.getactivityTypeList();
		this.getList();
	},
	methods: {
		// 搜索建议
		querySearchAsync(queryString, cb) {
			queryString ? this.getList('filter') : '';
			clearTimeout(this.timeout);
			this.timeout = setTimeout(() => {
				cb(this.scenicSpotList);
			}, 1000 * Math.random());
		},
		handleSelect(subInput) {
			this.formInline.name = subInput.name;
		},
		// 获取活动类型列表
		getactivityTypeList() {
			this.$http
				.get(this.api['DictionaryItems#index'].href, { params: { dictionaryCode: 'HEALTH_ACTIVITY_TYPE' } })
				.then((res) => {
					if (res.data && res.data.success) {
						this.activityTypeList = res.data.collection || [];
						this.activityTypeList.unshift({
							id: '',
							title: '全部',
						});
					}
				})
				.catch((e) => {});
		},
		// 查询条件
		onSearch() {
			this.queryData.current = 1;
			this.getList();
		},
		//选择改变
		selectionChange() {},
		//获取列表
		getList(type) {
			type == 'filter' ? (this.filterLoading = true) : (this.loading = true);
			let data = {
				...this.queryData,
				...this.formInline,
			};
			this.$http
				.get(this.api['HealthActivities#index'].href, { params: data })
				.then((res) => {
					if (res.data && res.data.success) {
						if (type == 'filter') {
							this.filterLoading = false;
							this.scenicSpotList = res.data.collection.map((item) => {
								return {
									...item,
									value: item.name,
								};
							});
						} else {
							this.loading = false;
							this.link = res.data._links.create.href || '';
							this.tableData = res.data.collection || [];
							this.total = res.data.pagination.totalItems || 0;
						}
					}
				})
				.catch((e) => {});
		},
		// 新增/修改/查看公园信息
		modifyParkInfo(event, isShowDetail, row) {
			let data = {
				row: row || null,
				link: row ? row._links.update.href : this.link,
			};
			this.$refs.newActivity.init(data);
			this.isShowDetail = isShowDetail;
		},

		onShow(row) {
			console.log(row);
			this.$refs.showList.showActivityVisible = true;
			this.$refs.showList.getShowList(row);
		},
		// 改变状态
		onChangeStatus(row) {
			this.$http.put(row._links.update.href, row).then((res) => {
				if (res.data && res.data.success) {
					this.$message.success(res.data.message);
					this.getList();
				}
			});
		},
	},
};
</script>

<style lang="scss" scoped>
/deep/ .search-form {
	.el-select {
		width: 120px;
		.el-input {
			width: 120px;
			.el-input__inner {
				width: 120px;
			}
		}
	}
	.el-input {
		width: 160px;
	}
}
.main-content {
	&-title {
		line-height: 48px;
		display: flex;
		justify-content: space-between;
		.el-button {
			line-height: 32px;
			padding: 0 16px;
			height: 32px;
			margin-top: 8px;
		}
	}
}
</style>
